import { gql } from "@apollo/client";
import { alpha } from "@mui/material";
import Stack from "atoms/Stack";
import { COLOR_PRIMARY_DARKER } from "helpers/colors";
import { sum } from "lodash-es";
import { videoPageContext } from "pages/VideoPage";
import React, { useContext } from "react";
import { useWindowSize } from "react-use-size";

export const VideoScoreboardFragment = gql`
  fragment VideoScoreboardFragment on Game {
    id
    home {
      id
    }
    away {
      id
    }
    periods {
      number
      name
    }
    events {
      id
      pointsScored
      occurredAtSeconds
      team {
        id
      }
    }
  }
`;

export default function VideoScoreboard({ game }) {
  const { currentTime, currentPeriodNumber } = useContext(videoPageContext);

  const homeScore = sum(
    game?.events
      .filter((e) => e.team?.id === game.home.id && e.occurredAtSeconds <= currentTime)
      .map((e) => e.pointsScored),
  );

  const awayScore = sum(
    game?.events
      .filter((e) => e.team?.id === game.away.id && e.occurredAtSeconds <= currentTime)
      .map((e) => e.pointsScored),
  );

  const scoreStyle = {
    fontSize: "0.9em",
    fontWeight: "bold",
  };

  const windowSize = useWindowSize();
  const smallScreen = windowSize.width < 500 || windowSize.height < 500;

  return (
    <Stack
      style={{
        fontSize: 22,
        lineHeight: 1,
        backgroundColor: alpha(COLOR_PRIMARY_DARKER, 0.3),
        borderRadius: 5,
        ...(smallScreen && { fontSize: 12 }),
      }}
      {...(smallScreen && { veryDense: true })}
      horizontal
      noWrap
      alignItemsCenter
      padding
      dense
    >
      <div style={scoreStyle}>{homeScore}</div>
      <div
        style={{
          fontSize: "0.6em",
          opacity: 0.8,
        }}
      >
        {game?.periods.find((p) => p.number === currentPeriodNumber)?.name}
      </div>
      <div style={scoreStyle}>{awayScore}</div>
    </Stack>
  );
}
